import type { ImageSizeType, ImageTypeName } from '@inter-ikea-kompis/core/types'

import { getProductImage } from '@sofa-platform/dexf-utils/src/utils/get-product-image'
import type { ProductData } from '@sofa-platform/types/src/types'

export function getProductImageOrFallbackProductAltText(
  productData: ProductData,
  size: ImageSizeType,
  typeName: ImageTypeName,
) {
  const img = getProductImage(productData, size, typeName)
  return { alt: img?.alt ?? getFallbackProductAltText(productData), src: img?.src }
}

function getFallbackProductAltText(productData: ProductData) {
  return `${productData.content.name} ${productData.content.typeName} ${productData.content.validDesignText}`
}
